// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"39db4209","699":"2e2bc119"}[chunkId] + ".chunk.css";
};